import React from 'react';
import { Routes, Route } from "react-router-dom";
import PantallaBase from '../INE/PantallaBase/PantallaBase';
import PantallaBase3 from '../INE/PantallaBase3/PantallaBase3';
import PantallaBase14 from '../INE/PantallaBase14/PantallaBase14';
import PantallaBase22 from '../INE/PantallaBase22/PantallaBase22';
import PantallaBase26 from '../INE/PantallaBase26/PantallaBase26';
import PantallaBase27 from '../INE/PantallaBase27/PantallaBase27';
import PantallaBase28 from '../INE/PantallaBase28/PantallaBase28';
import PantallaBase2Lic from '../Licencia/PantallaBase2Lic/PantallaBase2Lic';
import PantallaBase3Lic from '../Licencia/PantallaBase3Lic/PantallaBase3Lic';
import PantallaBase8Lic from '../Licencia/PantallaBase8Lic/PantallaBase8Lic';
import PantallaBase49Lic from '../Licencia/PantallaBase49Lic/PantallaBase49Lic';
import PantallaBase51Lic from '../Licencia/PantallaBase51Lic/PantallaBase51Lic';
import PantallaBase1Pass from '../Pasaporte/PantallaBase1Pass/PantallaBase1Pass';
import PantallaBase28Pass from '../Pasaporte/PantallaBase28Pass/PantallaBase28Pass';
import AppIncode from '../FlujoIncode/AppIncode';
import AppIncodeLicencia from '../FlujoIncodeLicencia/AppIncodeLicencia';
import AppIncodePasaporte from '../FlujoIncodePasaporte/AppIncodePasaporte';
import ValidacionFace from '../FlujoIncodePasaporte/ValidacionFace';
import AppIncodeDocument from '../FlujoIncodeDocumento/AppIncodeDocument';
import FaceLogin from '../FlujoIncodeLicencia/FaceLogin';
import FaceLoginPassaporte from '../FlujoIncodePasaporte/FaceLoginPassaporte';
import TipoLicencia from '../FAQ/FlujoLicencia/TipoLicencia';
import NumeroLic from '../FAQ/FlujoLicencia/NumeroLic';
import LicDate from '../FAQ/FlujoLicencia/LicDate';
import HomeLicConducir from '../FAQ/FlujoLicencia/HomeLicConducir';
import ValidacionLicencia from '../FlujoIncodeLicencia/ValidacionLicencia';
import HomeDomPersonal from '../FAQ/FlujoDomPersonal/HomeDomPersonal';
import DirDomPersonal from '../FAQ/FlujoDomPersonal/DirDomPersonal';
import DataDomPersonal from '../FAQ/FlujoDomPersonal/DataDomPersonal';
import ValidarUbicacion from '../FAQ/FlujoDomPersonal/ValidarUbicacion';
import CompDomPersonal from '../FAQ/FlujoDomPersonal/CompDomPersonal';
import HomeExpProfesional from '../ExperienciaProfesional/HomeExpProfesional';
import QuestionExpProfesional from '../ExperienciaProfesional/QuestionExpProfesional';
import ValidarData from '../ExperienciaProfesional/ValidarData';
import HomeConocimientoVial from '../ConocimientoVial/HomeConocimientoVial';
import QuestionConocimientoVial from '../ConocimientoVial/QuestionConocimientoVial';
import ValidarDataVial from '../ConocimientoVial/ValidarDataVial';
import QuestionConVial from '../FAQ/FlujoLicencia/QuestionConVial';
import FunctionalComponent from '../Reporte/FunctionalComponent';
import PsicometricoReporte from '../Reporte/PsicometricoReporte';
import FisicaReporte from '../Reporte/FisicaReporte';
import CapacidadEndeudamiento from '../Reporte/CapacidadEndeudamiento';
import SocioEconomico from '../Reporte/SocioEconomico';

import AutoTransporte from '../Reporte/AutoTransporte';
import Laboral from '../Reporte/Laboral';
import N1Beta from '../Reporte/N1Beta';
import N5BLaboral from '../Reporte/N5_B_Laboral';
import N2BDomicilio from '../Reporte/N2_B_Domicilio';
import N4_Historial from '../Reporte/N4_Historial';
import SocioEconomicoB from '../Reporte/SocioEconomicoB';
import N3_Autenticacion from '../Reporte/N3_Autenticacion';
import PsicometricoReporteB from '../Reporte/PsicometricoReporteB';
import CapacidadEndeudamientoSolvenciaB from '../Reporte/CapacidadEndeudamientoSolvenciaB';
import BackgroundCheck from '../Reporte/Background_Check';
import N5BackgroundCheck from '../Reporte/N5Background_Check';
import PsicometricoReporteC from '../Reporte/PsicometricoReporteC';
import N5BackgroundCheckPalenca from '../Reporte/N5BackgroundCheckPalenca';

import N1Jumio from '../Reporte/N1_Jumio';
import N2_B_Domicilio_Jumio from '../Reporte/N2_B_Domicilio_Jumio';
import N5BLaboral_Jumio from '../Reporte/N5_B_Laboral_Jumio';
import Background_Check_Jumio from '../Reporte/Background_Check_Jumio';
import N5B_BGC_Jumio from '../Reporte/N5B_BGC_Jumio';
import PsicometricoReporteC_Jumio from '../Reporte/PsicometricoReporteC_Jumio';
import N5BackgroundCheckPalenca_jumio from '../Reporte/N5BackgroundCheckPalenca_jumio';
import CapacidadEndeudamientoSolvenciaB_Jumio from '../Reporte/CapacidadEndeudamientoSolvenciaB_Jumio';
import SocioEconomicoB_Jumio from '../Reporte/SocioEconomicoB_Jumio';
import AutoTransporte_Jumio from '../Reporte/AutoTransporte_Jumio';
import PsicometricoReporteB_Jumio from '../Reporte/PsicometricoReporteB_Jumio';

function AppRoute() {

    return (
        <>
            <Routes>
                <Route path="/*" element={<PantallaBase />} />
                <Route path="/PantallaBase" element={<PantallaBase />} />
                <Route path="/PantallaBase3" element={<PantallaBase3 />} />
                <Route path="/PantallaBase14" element={<PantallaBase14 />} />
                <Route path="/PantallaBase22" element={<PantallaBase22 />} />
                <Route path="/PantallaBase26" element={<PantallaBase26 />} />
                <Route path="/PantallaBase27" element={<PantallaBase27 />} />
                <Route path="/PantallaBase28" element={<PantallaBase28 />} />
                <Route path="/PantallaBase2Lic" element={<PantallaBase2Lic />} />
                <Route path="/PantallaBase3Lic" element={<PantallaBase3Lic />} />
                <Route path="/PantallaBase8Lic" element={<PantallaBase8Lic />} />
                <Route path="/PantallaBase49Lic" element={<PantallaBase49Lic />} />
                <Route path="/PantallaBase51Lic" element={<PantallaBase51Lic />} />
                <Route path="/PantallaBase1Pass" element={<PantallaBase1Pass />} />
                <Route path="/PantallaBase28Pass" element={<PantallaBase28Pass />} />
                <Route path="/AppIncode" element={<AppIncode />} />
                <Route path="/AppIncodeLicencia" element={<AppIncodeLicencia />} />
                <Route path="/AppIncodePasaporte" element={<AppIncodePasaporte />} />
                <Route path="/AppIncodeDocument" element={<AppIncodeDocument />} />
                <Route path="/FaceLogin" element={<FaceLogin />} />
                <Route path="/FaceLoginPassaporte" element={<FaceLoginPassaporte />} />
                <Route path="/TipoLicencia" element={<TipoLicencia />} />
                <Route path="/NumeroLic" element={<NumeroLic />} />
                <Route path="/LicDate" element={<LicDate />} />
                <Route path="/HomeLicConducir" element={<HomeLicConducir />} />
                <Route path="/HomeDomPersonal" element={<HomeDomPersonal />} />
                <Route path="/DirDomPersonal" element={<DirDomPersonal />} />
                <Route path="/DataDomPersonal" element={<DataDomPersonal />} />
                <Route path="/CompDomPersonal" element={<CompDomPersonal />} />
                <Route path="/ValidarUbicacion" element={<ValidarUbicacion />} />
                <Route path="/HomeExpProfesional" element={<HomeExpProfesional />} />
                <Route path="/QuestionExpProfesional" element={<QuestionExpProfesional />} />
                <Route path="/ValidarData" element={<ValidarData />} />
                <Route path="/HomeConocimientoVial" element={<HomeConocimientoVial />} />
                <Route path="/QuestionConocimientoVial" element={<QuestionConocimientoVial />} />
                <Route path="/ValidarDataVial" element={<ValidarDataVial />} />
                <Route path="/QuestionConVial" element={<QuestionConVial />} />
                <Route path="/FunctionalComponent" element={<FunctionalComponent />} />
                <Route path='/FisicaComponent' element={<FisicaReporte />} />
                <Route path='/EndeudamientoReporte' element={<CapacidadEndeudamiento />} />
                <Route path='/PsicometricoComponent' element={<PsicometricoReporte />} />
                <Route path='/PsicometricoReporteB' element={<PsicometricoReporteB />} />
                <Route path='/SocioEconomicoReporte' element={<SocioEconomico />} />
                <Route path="/ValidacionLicencia" element={<ValidacionLicencia />} />
                <Route path="/ValidacionFace" element={<ValidacionFace />} />
                <Route path="/FisicaReporte" element={<FisicaReporte />} />
                <Route path="/CapacidadEndeudamiento" element={<CapacidadEndeudamiento />} />
                <Route path="/PsicometricoReporte" element={<PsicometricoReporte />} />
                <Route path="/SocioEconomico" element={<SocioEconomico />} />
                <Route path="/SocioEconomicoB" element={<SocioEconomicoB />} />
                <Route path="/AutoTransporte" element={<AutoTransporte />} />
                <Route path="/Laboral" element={<Laboral />} />
                <Route path="/N1Beta" element={<N1Beta />} />
                <Route path="/N5BLaboral" element={<N5BLaboral />} />
                <Route path="/N2BDomicilio" element={<N2BDomicilio />} />
                <Route path='/N4Historial' element={<N4_Historial />} />
                <Route path="/N3Autenticacion" element={<N3_Autenticacion />} />
                <Route path="/ReporteSolvenciaB" element={<CapacidadEndeudamientoSolvenciaB />} />
                <Route path="/BackgroundCheck" element={<BackgroundCheck />} />
                <Route path="/N5BackgroundCheck" element={<N5BackgroundCheckPalenca />} />
                <Route path="/PsicometricoReporteC" element={<PsicometricoReporteC />} />
                <Route path="/N5BackgroundCheckPalenca" element={<N5BackgroundCheckPalenca />} />

                {/* Reportes de Jumio */}

                <Route path="/N1Beta_Jumio" element={<N1Jumio />} />
                <Route path="/N2BDomicilio_Jumio" element={<N2_B_Domicilio_Jumio />} />
                <Route path="/N5BLaboral_Jumio" element={<N5BLaboral_Jumio />} />
                <Route path="/BackgroundCheck_Jumio" element={<Background_Check_Jumio />} />
                <Route path="/N5B_BGC_Jumio" element={<N5B_BGC_Jumio />} />
                <Route path="/PsicometricoReporteC_Jumio" element={<PsicometricoReporteC_Jumio />} />
                <Route path="/PsicometricoReporteB_Jumio" element={<PsicometricoReporteB_Jumio />} />
                <Route path="/N5BackgroundCheck_Jumio" element={<N5BackgroundCheckPalenca_jumio />} />
                <Route path="/ReporteSolvenciaB_Jumio" element={<CapacidadEndeudamientoSolvenciaB_Jumio />} />
                <Route path="/SocioEconomicoB_Jumio" element={<SocioEconomicoB_Jumio />} />
                <Route path="/AutoTransporte_Jumio" element={<AutoTransporte_Jumio />} />

            </Routes>
        </>
    )
}

export default AppRoute
